import { Divider } from 'primereact/divider';
import { useMemo } from 'react';
import PageWrapper from '../../../components/Display/PageWrapper';
import DevicePieChart from './DevicePieChart';
import VisitsBarChart from './VisitsBarChart';

function AnalyticsPage({ isActive, config }) {
  const getCharts = useMemo(() => {
    const charts = [];
    config.forEach((c) => {
      switch (c.chartType) {
        case 'visitBarChart':
          charts.push(<VisitsBarChart key={c.page} config={c} />);
          break;

        case 'devicePieChart':
          charts.push(<DevicePieChart key={c.page} config={c} />);
          break;

        default:
          console.log('Chart Type not found');
          break;
      }
    });
    return charts;
  }, []);

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label="Mesure d'audience">
        {getCharts.map((chart, index) => (
          <div key={index}>
            {chart}
            <Divider className="last:hidden" />
          </div>
        ))}
      </PageWrapper>
    </div>
  );
}

export default AnalyticsPage;
